import React, { useState, useEffect, useRef, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { FiArrowRight } from 'react-icons/fi';
import './Hero.css';

const Hero = () => {
  const [entered, setEntered] = useState(false);
  const heroRef = useRef(null);
  const decorRef = useRef(null);

  useEffect(() => {
    const hasLoader = !sessionStorage.getItem('dbh-loader-seen');
    const delay = hasLoader ? 5200 : 100;
    const t = setTimeout(() => setEntered(true), delay);
    return () => clearTimeout(t);
  }, []);

  const handleMouseMove = useCallback((e) => {
    if (!heroRef.current) return;
    const rect = heroRef.current.getBoundingClientRect();
    const x = (e.clientX - rect.left) / rect.width - 0.5;
    const y = (e.clientY - rect.top) / rect.height - 0.5;

    if (decorRef.current) {
      decorRef.current.style.transform =
        `translate(${x * 6}px, ${y * 6}px)`;
    }

    const parallaxEls = heroRef.current.querySelectorAll('[data-parallax]');
    parallaxEls.forEach((el) => {
      const depth = parseFloat(el.dataset.parallax) || 1;
      el.style.transform =
        `translate(${x * 4 * depth}px, ${y * 4 * depth}px)`;
    });
  }, []);

  return (
    <section
      ref={heroRef}
      className={`hero ${entered ? 'hero--entered' : ''}`}
      style={{ backgroundImage: `url('/hero-home.png')` }}
      onMouseMove={handleMouseMove}
    >
      <div className="container hero-container">
        <div className="hero-content">

          <div className="hero-eyebrow hero-anim-item" data-delay="0">
            <span className="hero-eyebrow-dot" />
            Data Intelligence
          </div>

          <h1 className="hero-title hero-anim-item" data-delay="1">
            From <span className="hero-title-blue">Data</span> to Better{' '}
            <span className="hero-title-blue">Decisions.</span>
          </h1>

          <p className="hero-desc hero-anim-item" data-delay="2">
            We help businesses collect, organise, mine and analyse data to uncover
            patterns, improve processes and make better decisions.
          </p>

          <div className="hero-cta hero-anim-item" data-delay="3">
            <Link to="/services" className="btn btn-primary">
              Explore Solutions <FiArrowRight />
            </Link>
            <Link to="/contact-us" className="btn btn-secondary">
              Talk to an Expert
            </Link>
          </div>
        </div>

        {/* Decorative floating elements */}
        <div className="hero-decor" ref={decorRef}>
          <div className="decor-chart" data-parallax="1.5">
            <svg width="64" height="48" viewBox="0 0 64 48" fill="none">
              <rect x="2" y="28" width="8" height="18" rx="2" fill="#037eb7" opacity="0.25" />
              <rect x="14" y="20" width="8" height="26" rx="2" fill="#037eb7" opacity="0.4" />
              <rect x="26" y="12" width="8" height="34" rx="2" fill="#037eb7" opacity="0.6" />
              <rect x="38" y="6" width="8" height="40" rx="2" fill="#037eb7" opacity="0.8" />
              <rect x="50" y="2" width="8" height="44" rx="2" fill="#037eb7" />
            </svg>
          </div>

          <div className="decor-dots" data-parallax="2">
            <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
              <circle cx="4" cy="4" r="2.5" fill="#037eb7" opacity="0.3" />
              <circle cx="16" cy="4" r="2.5" fill="#037eb7" opacity="0.5" />
              <circle cx="28" cy="4" r="2.5" fill="#037eb7" opacity="0.7" />
              <circle cx="4" cy="16" r="2.5" fill="#037eb7" opacity="0.5" />
              <circle cx="16" cy="16" r="2.5" fill="#037eb7" opacity="0.7" />
              <circle cx="28" cy="16" r="2.5" fill="#037eb7" />
              <circle cx="4" cy="28" r="2.5" fill="#037eb7" opacity="0.7" />
              <circle cx="16" cy="28" r="2.5" fill="#037eb7" />
            </svg>
          </div>

          <div className="decor-line-chart" data-parallax="1.2">
            <svg width="80" height="40" viewBox="0 0 80 40" fill="none">
              <polyline
                points="0,35 16,28 32,32 48,18 64,10 80,4"
                stroke="#2e3f51"
                strokeWidth="2"
                strokeLinecap="round"
                opacity="0.2"
              />
              <circle cx="48" cy="18" r="3" fill="#037eb7" opacity="0.6" />
              <circle cx="80" cy="4" r="3.5" fill="#037eb7" />
            </svg>
          </div>

          <div className="decor-icon-dec" data-parallax="1.8">
            <svg width="28" height="28" viewBox="0 0 28 28" fill="none">
              <path d="M14 2L18 10H26L20 15L22 24L14 19L6 24L8 15L2 10H10L14 2Z" fill="#037eb7" opacity="0.15" />
            </svg>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
